<template>
    <div>
        <h1>Common Royalty Distribution: EDI format specifications Version 3.0 Revision 5</h1>
        <v-btn text @click="selectFile"><v-icon color="green">edit</v-icon></v-btn>
        <v-btn text @click="saveXlsx"><v-icon color="green">save</v-icon></v-btn>
        <v-btn text @click="guardarBD"><v-icon color="blue">database</v-icon></v-btn>


        <input v-on="file" ref="fileSelector" accept="*" type="file" class="d-none" multiple @change="upload">
        <v-data-table :loading="loading" item-class="class" :headers="headers" dense :items="filas">
            <template v-slot:item.participacion="{ item }">
                {{ item.participacion.toFixed(2) }}
            </template>
            <template v-slot:item.monto="{ item }">
                {{ item.monto.toFixed(2) }}
            </template>
            <template v-slot:item.grossAmt="{ item }">
                {{ item.grossAmt.toFixed(2) }}
            </template>
            <template v-slot:item.taxAmt="{ item }">
                {{ item.taxAmt.toFixed(2) }}
            </template>
            <template v-slot:item.commAmt="{ item }">
                {{ item.commAmt.toFixed(2) }}
            </template>
        </v-data-table>
        <v-row v-if="filas.length" class="pa-4" dense>
            <v-col><strong>Total filas:</strong> {{ filas.length }}</v-col>
            <v-col><strong>Total Bruto:</strong> {{ totalGrossAmt.toFixed(2) }}</v-col>
            <v-col><strong>Total Impuestos:</strong> {{ totalTaxAmt.toFixed(2) }}</v-col>
            <v-col><strong>Total Comisión:</strong> {{ totalCommAmt.toFixed(2) }}</v-col>
            <v-col><strong>Monto total:</strong> {{ totalMonto.toFixed(2) }}</v-col>
        </v-row>

    </div>
</template>

<script>
import axios from "axios";
// import { saveAs } from "file-saver";
import { saveAs } from "file-saver";
import { utils, write } from "xlsx";
import JSZip from "jszip";


export default {
    data() {
        return {
            headers: [
                { text: "ID Sender", value: "senderId" },
                { text: "Sender Name", value: "senderName" },
                { text: "ID Distribución", value: "distributionId" },
                { text: "Creation Date/Time", value: "creationDateTime" },
                { text: "Transmission Date", value: "transmissionDate" },
                { text: "Tipo", value: "tipo" },
                { text: "Fecha", value: "fecha" },
                { text: "Hora", value: "hora" },
                { text: "Channel", value: "channel" },
                { text: "Obra", value: "obra" },
                { text: "IP", value: "ip" },
                { text: "Autor", value: "autor" },
                { text: "Partic.%", value: "participacion" },
                { text: "Monto Bruto", value: "grossAmt", align: 'end' },
                { text: "Impuestos", value: "taxAmt", align: 'end' },
                { text: "Comisión", value: "commAmt", align: 'end' },
                { text: "Monto", value: "monto", align: 'end' },
                { text: "Moneda", value: "moneda" },


            ],
            POSITIONS: {
                HDR: {
                    senderId: 5, senderIdLen: 9,                    // Pos 6: Sender ID
                    senderName: 14, senderNameLen: 45,              // Pos 15: Nombre del sender
                    creationDate: 64, creataionDateLen: 8,          //pos 65: The date that this file was created.
                    creationTime: 72, creationTimeLen: 6,           // Pos 73 The time of day that this file was created.
                    transmissionDate: 78, transmissionDateLen: 8,  // Pos 79: The date that this file was transmitted to all receiving entities.
                },
                SDN: {
                    distId: 19, distIdLen: 10,           // Pos 20: ID de Distribución
                    amountDec: 112,                      // Pos 113: Decimales para montos
                    percentDec: 113,                     // Pos 114: Decimales para porcentajes
                    versionNumber: 114, versionNumberLen: 5, // Pos 115: Versión EDI (ej. 03.05)
                    remittanceCur: 119, remittanceCurLen: 3  // Pos 120: Moneda de remesa (ej. ARS)
                },
                ESI: {
                    sourceId: 19, sourceIdLen: 20,       // Pos 20: ID Fuente de explotación
                    sourceName: 39, sourceNameLen: 30    // Pos 40: Nombre del medio (ej. VORTERIX)
                },
                IPI: {
                    ipNumber: 19, ipNumberLen: 11,       // Pos 20: ID del Interesado
                    ipName: 42, ipNameLen: 90            // Pos 43: Nombre completo
                },
                MWN: {
                    workTitle: 33, workTitleLen: 60      // Pos 34: Título de la obra
                },
                MIP: {
                    ipNumber: 19, ipNumberLen: 11,       // Pos 20: ID del Interesado en la obra
                    sharePct: 45, sharePctLen: 8         // Pos 46: % de participación
                },
                // Registro de Ejecución Pública
                WEP: {
                    refId: 19, refIdLen: 15,             // Pos 20: ID único de la línea de pago
                    sourceId: 36, sourceIdLen: 20,       // Pos 37: ID del medio
                    expDate: 69, expDateLen: 8,          // Pos 70: Fecha (YYYYMMDD)
                    expTime: 77, expTimeLen: 4,          // Pos 78: Hora (HHMM)
                    isrc: 81, isrcLen: 12,               // Pos 82: Código ISRC
                    grossAmt: 197, grossAmtLen: 18,      // Pos 198: Monto Bruto
                    taxAmt: 223, taxAmtLen: 18,          // Pos 224: Impuestos retenidos
                    commAmt: 241, commAmtLen: 18,        // Pos 242: Comisión de la sociedad
                    remittedAmt: 298, remittedAmtLen: 18 // Pos 299: Monto Neto final
                },
                // Registro de Explotación Audiovisual
                WEA: {
                    refId: 19, refIdLen: 15,             // Pos 20: ID único de la línea de pago [1]
                    sourceId: 36, sourceIdLen: 20,       // Pos 37: ID del medio (ej. Canal de TV) [1]
                    expDate: 69, expDateLen: 8,          // Pos 70: Fecha de emisión [1]
                    expTime: 77, expTimeLen: 4,          // Pos 78: Hora de emisión [1]
                    isrc: 81, isrcLen: 12,               // Pos 82: Código ISRC [1]
                    grossAmt: 141, grossAmtLen: 18,      // Pos 142: Monto Bruto [1]
                    taxAmt: 167, taxAmtLen: 18,          // Pos 168: Impuestos retenidos [1]
                    commAmt: 185, commAmtLen: 18,        // Pos 186: Comisión de la sociedad [1]
                    remittedAmt: 242, remittedAmtLen: 18 // Pos 243: Monto Neto final [1]
                },
                // Registro de Reproducción Mecánica (para archivos MEC)
                WER: {
                    refId: 19, refIdLen: 15,             // Pos 20: ID único de la línea de pago
                    recProductNo: 68, recProductNoLen: 20, // Pos 69: ID del Producto Grabado
                    grossAmt: 248, grossAmtLen: 18,      // Pos 249: Monto Bruto
                    taxAmt: 274, taxAmtLen: 18,          // Pos 275: Impuestos retenidos
                    commAmt: 292, commAmtLen: 18,        // Pos 293: Comisión de la sociedad
                    remittedAmt: 349, remittedAmtLen: 18 // Pos 350: Monto Neto final
                },
                // Totales de Control
                RGT: {
                    totalNetAmt: 19, totalNetAmtLen: 18  // Pos 20: Gran total neto del archivo
                }
            },
            file: null,
            errorMessage: "",
            loading: false,
            filas: []
        };
    },
    methods: {
        selectFile() {
            this.dialog = true;
            console.log('*** selectFile')
            console.log('select file', this.$refs)
            console.log('select file', this.$refs.fileSelector.click())
        },
        async upload(a) {
            this.loading = true;
            this.filas = [];
            for (const file of a.target.files) {
                await this.parseCRD(file);
            }
            this.loading = false;
        },
        async parseCRD(file) {

            if (!file) return;
            const lines = await this.readFileLines(file);

            // lines.forEach((line, i) => {
            //     console.log(i, line);
            // });

            const POSITIONS = this.POSITIONS;

            const ipiMap = {};
            const esiMap = {};  // Mapa para ID Fuente -> Nombre Medio
            let currentWork = "";
            let lastMIP = null;
            let decimals = { amt: 2, pct: 2 };
            let currency = "";
            let distributionId = "";
            let senderId = "";
            let senderName = "";
            let creationDateTime = "";
            let transmissionDate = "";


            for await (const line of lines) {

                const type = line.substring(0, 3);


                switch (type) {

                    case 'HDR': {
                        senderId = line.substring(POSITIONS.HDR.senderId, POSITIONS.HDR.senderId + POSITIONS.HDR.senderIdLen).trim();
                        senderName = line.substring(POSITIONS.HDR.senderName, POSITIONS.HDR.senderName + POSITIONS.HDR.senderNameLen).trim();
                        const creationDate = line.substring(POSITIONS.HDR.creationDate, POSITIONS.HDR.creationDate + POSITIONS.HDR.creataionDateLen);
                        const creationTime = line.substring(POSITIONS.HDR.creationTime, POSITIONS.HDR.creationTime + POSITIONS.HDR.creationTimeLen);
                        creationDateTime = `${creationDate}${creationTime}`;     
                        transmissionDate = line.substring(POSITIONS.HDR.transmissionDate, POSITIONS.HDR.transmissionDate + POSITIONS.HDR.transmissionDateLen);                 
                        break;
                    }

                    case 'SDN': {

                        decimals.amt = parseInt(line[POSITIONS.SDN.amountDec]);
                        decimals.pct = parseInt(line[POSITIONS.SDN.percentDec]);
                        currency = line.substring(POSITIONS.SDN.remittanceCur, POSITIONS.SDN.remittanceCur + POSITIONS.SDN.remittanceCurLen).trim();
                        distributionId = line.substring(POSITIONS.SDN.distId, POSITIONS.SDN.distId + POSITIONS.SDN.distIdLen).trim();
                        break;
                    }

                    case 'ESI': {
                        const sId = line.substring(POSITIONS.ESI.sourceId, POSITIONS.ESI.sourceId + POSITIONS.ESI.sourceIdLen).trim();
                        const sName = line.substring(POSITIONS.ESI.sourceName, POSITIONS.ESI.sourceName + POSITIONS.ESI.sourceNameLen).trim();
                        esiMap[sId] = sName;
                        break;
                    }

                    case 'IPI': {
                        const ipNum = line.substring(POSITIONS.IPI.ipNumber, POSITIONS.IPI.ipNumber + POSITIONS.IPI.ipNumberLen).trim();
                        ipiMap[ipNum] = line.substring(POSITIONS.IPI.ipName, POSITIONS.IPI.ipName + POSITIONS.IPI.ipNameLen).trim();
                        break;
                    }

                    case 'MWN': {
                        currentWork = line.substring(POSITIONS.MWN.workTitle, POSITIONS.MWN.workTitle + POSITIONS.MWN.workTitleLen).trim();
                        break;
                    }

                    case 'MIP': {
                        const mipIp = line.substring(POSITIONS.MIP.ipNumber, POSITIONS.MIP.ipNumber + POSITIONS.MIP.ipNumberLen).trim();
                        const rawPct = line.substring(POSITIONS.MIP.sharePct, POSITIONS.MIP.sharePct + POSITIONS.MIP.sharePctLen);
                        lastMIP = { ip: mipIp, percent: parseFloat(rawPct) / Math.pow(10, decimals.pct) };
                        break;
                    }

                    case 'WEP': {
                        if (lastMIP) {
                            const sourceId = line.substring(POSITIONS.WEP.sourceId, POSITIONS.WEP.sourceId + POSITIONS.WEP.sourceIdLen).trim();
                            const date = line.substring(POSITIONS.WEP.expDate, POSITIONS.WEP.expDate + POSITIONS.WEP.expDateLen);
                            const time = line.substring(POSITIONS.WEP.expTime, POSITIONS.WEP.expTime + POSITIONS.WEP.expTimeLen);
                            const rawAmt = line.substring(POSITIONS.WEP.remittedAmt, POSITIONS.WEP.remittedAmt + POSITIONS.WEP.remittedAmtLen);
                            const rawGross = line.substring(POSITIONS.WEP.grossAmt, POSITIONS.WEP.grossAmt + POSITIONS.WEP.grossAmtLen);
                            const rawTax = line.substring(POSITIONS.WEP.taxAmt, POSITIONS.WEP.taxAmt + POSITIONS.WEP.taxAmtLen);
                            const rawComm = line.substring(POSITIONS.WEP.commAmt, POSITIONS.WEP.commAmt + POSITIONS.WEP.commAmtLen);

                            const formattedDate = `${date.slice(6, 8)}/${date.slice(4, 6)}/${date.slice(0, 4)}`;
                            const formattedTime = `${time.slice(0, 2)}:${time.slice(2, 4)}`;
                            const amount = parseFloat(rawAmt) / Math.pow(10, decimals.amt);
                            const gross = parseFloat(rawGross) / Math.pow(10, decimals.amt);
                            const tax = parseFloat(rawTax) / Math.pow(10, decimals.amt);
                            const comm = parseFloat(rawComm) / Math.pow(10, decimals.amt);
                            const sourceName = esiMap[sourceId] || sourceId;

                            this.filas.push({
                                tipo: type,
                                senderId: senderId,
                                senderName: senderName,
                                distributionId: distributionId,
                                creationDateTime: creationDateTime,
                                transmissionDate: transmissionDate,
                                fecha: formattedDate,
                                hora: formattedTime,
                                channel: sourceName.padEnd(10),
                                obra: currentWork.padEnd(15),
                                ip: lastMIP.ip,
                                autor: ipiMap[lastMIP.ip].padEnd(25),
                                participacion: lastMIP.percent,
                                grossAmt: gross,
                                taxAmt: tax,
                                commAmt: comm,
                                monto: amount,
                                moneda: currency,
                            })
                        }
                        break;
                    }
                    case 'WEA': {
                        if (lastMIP) {
                            const sourceId = line.substring(POSITIONS.WEA.sourceId, POSITIONS.WEA.sourceId + POSITIONS.WEA.sourceIdLen).trim();
                            const date = line.substring(POSITIONS.WEA.expDate, POSITIONS.WEA.expDate + POSITIONS.WEA.expDateLen);
                            const time = line.substring(POSITIONS.WEA.expTime, POSITIONS.WEA.expTime + POSITIONS.WEA.expTimeLen);
                            const rawAmt = line.substring(POSITIONS.WEA.remittedAmt, POSITIONS.WEA.remittedAmt + POSITIONS.WEA.remittedAmtLen);
                            const rawGross = line.substring(POSITIONS.WEA.grossAmt, POSITIONS.WEA.grossAmt + POSITIONS.WEA.grossAmtLen);
                            const rawTax = line.substring(POSITIONS.WEA.taxAmt, POSITIONS.WEA.taxAmt + POSITIONS.WEA.taxAmtLen);
                            const rawComm = line.substring(POSITIONS.WEA.commAmt, POSITIONS.WEA.commAmt + POSITIONS.WEA.commAmtLen);

                            const formattedDate = `${date.slice(6, 8)}/${date.slice(4, 6)}/${date.slice(0, 4)}`;
                            const formattedTime = `${time.slice(0, 2)}:${time.slice(2, 4)}`;
                            const amount = parseFloat(rawAmt) / Math.pow(10, decimals.amt);
                            const gross = parseFloat(rawGross) / Math.pow(10, decimals.amt);
                            const tax = parseFloat(rawTax) / Math.pow(10, decimals.amt);
                            const comm = parseFloat(rawComm) / Math.pow(10, decimals.amt);
                            const sourceName = esiMap[sourceId] || sourceId;

                            this.filas.push({
                                tipo: type,
                                senderId: senderId,
                                senderName: senderName,
                                distributionId: distributionId,
                                creationDateTime: creationDateTime,
                                transmissionDate: transmissionDate,
                                fecha: formattedDate,
                                hora: formattedTime,
                                channel: sourceName.padEnd(10),
                                obra: currentWork.padEnd(15),
                                ip: lastMIP.ip,
                                autor: ipiMap[lastMIP.ip].padEnd(25),
                                participacion: lastMIP.percent,
                                grossAmt: gross,
                                taxAmt: tax,
                                commAmt: comm,
                                monto: amount,
                                moneda: currency,
                            })
                        }
                        break;
                    }
                    case 'WER': {
                        if (lastMIP) {
                            const sourceId = line.substring(POSITIONS.WER.recProductNo, POSITIONS.WER.recProductNo + POSITIONS.WER.recProductNoLen).trim();
                            const date = line.substring(POSITIONS.WEP.expDate, POSITIONS.WEP.expDate + POSITIONS.WEP.expDateLen);
                            const time = line.substring(POSITIONS.WEP.expTime, POSITIONS.WEP.expTime + POSITIONS.WEP.expTimeLen);
                            const rawAmt = line.substring(POSITIONS.WER.remittedAmt, POSITIONS.WER.remittedAmt + POSITIONS.WER.remittedAmtLen);
                            const rawGross = line.substring(POSITIONS.WER.grossAmt, POSITIONS.WER.grossAmt + POSITIONS.WER.grossAmtLen);
                            const rawTax = line.substring(POSITIONS.WER.taxAmt, POSITIONS.WER.taxAmt + POSITIONS.WER.taxAmtLen);
                            const rawComm = line.substring(POSITIONS.WER.commAmt, POSITIONS.WER.commAmt + POSITIONS.WER.commAmtLen);

                            const formattedDate = `${date.slice(6, 8)}/${date.slice(4, 6)}/${date.slice(0, 4)}`;
                            const formattedTime = `${time.slice(0, 2)}:${time.slice(2, 4)}`;
                            const amount = parseFloat(rawAmt) / Math.pow(10, decimals.amt);
                            const gross = parseFloat(rawGross) / Math.pow(10, decimals.amt);
                            const tax = parseFloat(rawTax) / Math.pow(10, decimals.amt);
                            const comm = parseFloat(rawComm) / Math.pow(10, decimals.amt);
                            const sourceName = esiMap[sourceId] || sourceId;

                            this.filas.push({
                                tipo: type,
                                senderId: senderId,
                                senderName: senderName,
                                distributionId: distributionId,
                                creationDateTime: creationDateTime,
                                transmissionDate: transmissionDate,
                                fecha: formattedDate,
                                hora: formattedTime,
                                channel: sourceName.padEnd(10),
                                obra: currentWork.padEnd(15),
                                ip: lastMIP.ip,
                                autor: ipiMap[lastMIP.ip].padEnd(25),
                                participacion: lastMIP.percent,
                                grossAmt: gross,
                                taxAmt: tax,
                                commAmt: comm,
                                monto: amount,
                                moneda: currency,
                            })
                        }
                        break;
                    }
                }
            }
        },
        readFileLines(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const text = e.target.result;
                    const lines = text.split(/\r?\n/);
                    resolve(lines);
                };

                reader.onerror = reject;

                reader.readAsText(file);
            });
        },
        async saveXlsx() {

            if (this.filas.length == 0) { return }

            this.loading = true;

            const zip = new JSZip();


            const wscols = [
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 40 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
            ];

            const chunkSize = 1000000;
            const cantidadArchivos = Math.ceil(this.filas.length / chunkSize);
            let nuneroArchvo = 1;
            const nombreArchivoBase = `EDI_`;

            try {

                for (let i = 0; i < this.filas.length; i += chunkSize) {

                    const chunk = this.filas.slice(i, i + chunkSize);

                    const ws = utils.json_to_sheet(chunk);
                    const wb = utils.book_new();
                    ws["!cols"] = wscols;
                    utils.book_append_sheet(wb, ws, "Hoja1");

                    const wbout = write(wb, { bookType: "xlsx", type: "buffer" });
                    zip.file(`${nombreArchivoBase}_${nuneroArchvo}_de_${cantidadArchivos}.xlsx`, wbout);
                    nuneroArchvo++;
                }

                const contenido = await zip.generateAsync({ type: "blob" });
                saveAs(contenido, `${nombreArchivoBase}.zip`);

                this.loading = false;

            } catch (error) {

                this.loading = false;
                console.error("Error al obtener el detalle:", error);

                // Opcional: lanzar un error personalizado
                //throw new Error("No se pudo obtener el detalle del pago");
                alert("Error al obtener el detalle :" + error);
            }
        },
        async guardarBD() {
            if (this.filas.length == 0) { return }
            this.loading = true;
            try {
                await axios.post("/crd", this.filas);
                alert("Guardado correctamente (" + this.filas.length + " registros)");
            } catch (error) {
                console.error("Error al guardar:", error);
                alert("Error al guardar: " + (error.response ? error.response.data : error.message));
            } finally {
                this.loading = false;
            }
        }



    },
    computed: {
        totalMonto() {
            return this.filas.reduce((sum, f) => sum + parseFloat(f.monto || 0), 0);
        },
        totalGrossAmt() {
            return this.filas.reduce((sum, f) => sum + parseFloat(f.grossAmt || 0), 0);
        },
        totalTaxAmt() {
            return this.filas.reduce((sum, f) => sum + parseFloat(f.taxAmt || 0), 0);
        },
        totalCommAmt() {
            return this.filas.reduce((sum, f) => sum + parseFloat(f.commAmt || 0), 0);
        }
    },
    components: {
    },
    filters: {
    },
};
</script>